import DeleteGame from './DeleteGame'
export default DeleteGame